module.exports = __webpack_public_path__ + "static/media/focus-clock-icon.700a0e4c.png";